import React from 'react';
import { setWeek } from 'date-fns';
import { useParams } from 'react-router';
import useObjectSearchParams from 'hooks/useObjectSearchParams';
import useSetDeleteURLParams from 'hooks/useSetDeleteURLParams';
import { getWeekForPlanning } from 'model/ResourcePlanning/utils';

interface MonthViewSearchParams {
  entityName: string;
  isMachine?: 'true';
  projectId: string;
  week: string;
  month: string;
  year: string;
}

const useMonthlyPlanningParams = () => {
  const { entityId } = useParams<{
    entityId: string;
  }>();
  const { entityName, isMachine, projectId, week, month, year } =
    useObjectSearchParams<MonthViewSearchParams>();
  const { setURLParam } = useSetDeleteURLParams<MonthViewSearchParams>();

  const weekNumber =
    (week && !Number.isNaN(Number(week)) && Number(week)) ||
    getWeekForPlanning(new Date());
  const yearNumber =
    (year && !Number.isNaN(Number(year)) && Number(year)) ||
    new Date().getFullYear();
  const monthNumber =
    (month && !Number.isNaN(Number(month)) && Number(month)) ||
    setWeek(new Date(yearNumber, 0, 15), weekNumber).getMonth();

  const params = React.useMemo(
    () => ({
      entityId: entityId || null,
      entityName,
      isMachine: !!isMachine,
      projectId,
      week: weekNumber,
      month: monthNumber,
      year: yearNumber,
      setURLParam,
    }),
    [entityId, entityName, isMachine, week, year, setURLParam]
  );

  return params;
};

export default useMonthlyPlanningParams;
